module.exports = __webpack_public_path__ + "media/images/head_cp-2f357e018c9a5983cb6b7415c31dc4f6.png";